import CityPageTemplate from "../city-template/CityPageTemplate";
import { valparaisoConfig } from "./data";

export default function ValparaisoPage() {
  return <CityPageTemplate config={valparaisoConfig} />;
}